<template>
    <v-card>
        <v-card-title>
          <h5 style="margin:0px" color="primary">{{characteristic.name}}</h5>
          <v-spacer />
      </v-card-title>
      <v-card-subtitle>
        {{ characteristic.description }}
      </v-card-subtitle>
      <v-divider style="margin:0px"></v-divider>
        <v-card-text>
        <v-row>
            <v-col>
                <div class="fieldname">Zugeordnete Abteilung</div>
                <ColorLegend
                  v-if="characteristic.department"
                  :items="[characteristic.department[0]]"
                >
                  <template #default="{ item }">
                    {{ item.friendlyName }}
                  </template>
                </ColorLegend>
                <v-chip v-else color="gray">N/A</v-chip>
            </v-col>
        </v-row>
        <v-row>
          <v-col><span class="fieldname">Prozessart:</span> {{ characteristic.customFields.find(elem => elem.customField.fieldId == 'prozessart') ? characteristic.customFields.find(elem => elem.customField.fieldId == 'prozessart').fieldValue : 'Keine Angabe' }}</v-col>
        </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import ColorLegend from '@/pages/ProcessMap/ColorLegend.vue';

export default {
  components: {
    ColorLegend
  },
  props:{
    characteristic: Object
  },
  mounted(){
  },
  methods: {
    close(){
        this.$emit("close");
    }
  },
}
</script>

<style scoped>
.v-tooltip__content {
  pointer-events: initial !important;
  background: none;
}
.col1{
    width: 60%;
}
.col2{
    width: 40%;
}
#textHighlight{

}
</style>
